import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Popover,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import BottomButton from "../components/BottomButton";
import { useStyles } from "../styles/useStyles";

import { IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CircularProgress from "@mui/material/CircularProgress";

import TextField from "../overightMui/TextField";

import icon_edit from "../../assets/icon_edit.svg";
import info_orange from "../../assets/info_orange.svg";
import check_ok_icon from "../../assets/check_ok_icon.svg";
import Icon_discountTF from "../../assets/Icon_discountTF.svg";
import CustomizedCheckbox from "../overightMui/Checkbox";
import Dialog_Bill from "../components/Dialog_Bill";
import dayjs from "dayjs";
import { get } from "lodash";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";
import qs from "qs";
import SuccessModal from "../components/SuccessModal";
import { formatMoney, sortObjectByKey } from "../utils";
import { getCollaboratorDetail, getStime } from "../../controller/api_zuttoride";

export default function Step_3({ state, dispatch, platform }) {
  const {
    loadingPrice,
    vehicleInfo,
    insuranceInfo,
    haveBill,
    fessTotal,
    redeemCode,
    cam_ket,
    commission,
    dialogSuccess,
    balance,
    orders
  } = state;
  const classes = useStyles();

  const isApp = platform === "app";
  const isZalo_mini = platform === "zalo_mini";
  const [reward, setReward] = useState(0);
  const [maxSubsidy, setMaxSubsidy] = useState(commission?.subsidyAmount);
  const [subsidyValue, setSubsidyValue] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);
  const [collaboratorInfo, setCollaboratorInfo] = useState(null);

  const extractToken = () => {
    const queryToken = new URLSearchParams(window.location.search).get("token");
    if (queryToken) return queryToken;

    const pathname = window.location.pathname;
    if (pathname.includes(".")) {
      const pathToken = pathname.split(".").pop();
      if (pathToken) return pathToken;
    }

    const segments = pathname.split("/").filter(Boolean);
    const knownRoutes = ["intro", "san-pham", "packeds"];
    const lastSegment = segments.pop();

    if (lastSegment && !knownRoutes.includes(lastSegment)) {
      return lastSegment;
    }

    return localStorage.getItem("token");
  };

  const token = extractToken();
  const OpenLink = (link) => {
    if (platform === "app") {
      // History.replace(`/gotoBrownser?link=${link}`);
      window.ReactNativeWebView.postMessage(`/gotoBrownser?link=${link}`);
    } else {
      window.open(link, "_blank");
    }
  };

  useEffect(() => {
    dispatch("init_step3");
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setReward(+balance >= +fessTotal ? fessTotal : balance);
  }, [balance]);

  useEffect(() => {
    setMaxSubsidy(commission?.subsidyAmount);
  }, [redeemCode?.nonCommission, commission?.subsidyAmount])

  useEffect(() => {
    dispatch({ type: "onChangeAppliedCommissionAmount", value: subsidyValue ? Number(subsidyValue) : "", maxValue: maxSubsidy });
  }, [subsidyValue, maxSubsidy]);

  useEffect(() => {
    const fetchCollaborator = async () => {
      try {
        const stimeRes = await getStime();
        if (!stimeRes?.data?.success) return;

        const env = process.env.REACT_APP_NODE_ENV || "";
        const data_ = qs.stringify(sortObjectByKey({}));
        const uuid = uuidv4();
        const client = md5(env + '-' + data_ + stimeRes.data.data.stime + uuid);
        const header = {
          'x-api-stime': stimeRes.data.data.stime,
          'x-api-nonce': uuid,
          'x-api-client': client,
        };

        const res = await getCollaboratorDetail(header);
        if (res?.data?.success) {
          setCollaboratorInfo(res.data.data);
        }
      } catch (err) {
        console.error("Failed to load collaborator details", err);
      }
    };
    if (token) {
      fetchCollaborator();
    }
  }, [token]);

  const infor_moto = [
    {
      name: "vehicleType",
      label: "Loại xe: ",
      value: vehicleInfo?.type?.title || "",
    },
    {
      name: "manufacture",
      label: "Hãng xe: ",
      value: vehicleInfo?.brand?.title,
    },
    {
      name: "motorbike",
      label: "Dòng xe:",
      value: vehicleInfo?.productLine?.title,
    },
    {
      name: "license",
      label: "Biển số xe:",
      value: vehicleInfo?.license || "",
    },
    { name: "chassis", label: "Số khung:", value: vehicleInfo?.chassis || "" },
    { name: "engine", label: "Số máy:", value: vehicleInfo?.engine || "" },
  ];

  const infor_user = [
    {
      name: "buyerName",
      label: "Họ và tên chủ xe: ",
      value: insuranceInfo?.buyerName || "",
    },
    {
      name: "buyerGender",
      label: "Giới tính: ",
      value: insuranceInfo?.buyerGender === 1 ? "Nam" : "Nữ",
    },
    {
      name: "buyerAddress",
      label: "Địa chỉ liên lạc: ",
      value: insuranceInfo?.buyerAddress || "",
    },
    {
      name: "buyerPhone",
      label: "Điện thoại: ",
      value: insuranceInfo?.buyerPhone || "",
    },
    {
      name: "buyerEmail",
      label: "Email: ",
      value: insuranceInfo?.buyerEmail || "",
    },
  ];

  const enough_infor_bill =
    insuranceInfo?.vatInfo?.type &&
    insuranceInfo?.vatInfo?.name &&
    insuranceInfo?.vatInfo?.taxCode &&
    insuranceInfo?.vatInfo?.address;

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.box_infor_user_3}>
          <div className="title_edit">
            <span> Thông tin người đăng ký</span>
            <IconButton
              onClick={() => {
                dispatch({ type: "editPage", name: "inforUser" });
              }}
            >
              <img src={icon_edit} alt="icon_edit" />
            </IconButton>
          </div>
          <div>
            {infor_user.map((item, index) => (
              <div className="box_line_infor" key={`line_infor_user_${index}`}>
                <span>{item.label}</span>
                <span className="fees">{item.value}</span>
              </div>
            ))}
            <div style={{
              display: "flex", flexDirection: "row", gap: 5, justifyContent: "space-between",
              marginTop: "12px",
              fontSize: 13
            }}>
              <div>
                Thời hạn BH:
              </div>
              <div style={{ textAlign: "right", fontWeight: 600 }}>
                0h00 ngày{" "}{dayjs(insuranceInfo?.validFrom).format("DD/MM/YYYY")}{" "}
                đến{" "}23h59 ngày{" "}
                {dayjs(insuranceInfo?.validUntil).format("DD/MM/YYYY")}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.box_infor_user_3}>
          <div className="title_edit">
            <span> Thông tin về xe</span>
            <IconButton
              onClick={() => {
                dispatch({ type: "editPage", name: "inforVehical" });
              }}
            >
              <img src={icon_edit} alt="icon_edit" />
            </IconButton>
          </div>
          <div>
            {infor_moto.map((item, index) => (
              <div className="box_line_infor" key={`line_infor_user_${index}`}>
                <span>{item.label}</span>
                <span className="fees">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
        {token && collaboratorInfo && (
          <div className={classes.box_infor_user_3}>
            <div className="title_edit" style={{paddingBottom: "7px"}}>
              <span> Thông tin cộng tác viên</span>
            </div>
            <div>
              <div className="box_line_infor">
                <span>Họ và tên:</span>
                <span className="fees">{collaboratorInfo.fullname || "---"}</span>
              </div>
              <div className="box_line_infor">
                <span>Mã số thuế:</span>
                <span className="fees">{collaboratorInfo.taxCode || "---"}</span>
              </div>
            </div>
          </div>
        )}
        <div className={classes.box_infor_bill_3}>
          <div className="title">Thông tin xuất hoá đơn</div>
          <div>
            <FormControl fullWidth>
              <RadioGroup
                row
                name="row-radio-buttons-group"
                sx={{ padding: "0 8px" }}
                value={haveBill}
                onChange={(e) => {
                  dispatch({
                    type: "onChangeRadioBill",
                    value: e.target.value,
                  });
                }}
              >
                <FormControlLabel
                  value="NO"
                  sx={{
                    "& .Mui-checked": { color: "#009B4B !important" },
                    marginRight: "36px",
                  }}
                  control={<Radio size="small" />}
                  label="Không"
                />
                <FormControlLabel
                  value="YES"
                  sx={{
                    "& .MuiRadio-root.Mui-checked": {
                      color: "#009B4B !important",
                    },
                  }}
                  control={<Radio size="small" />}
                  label="Có"
                />
              </RadioGroup>
            </FormControl>
            {haveBill === "YES" && (
              <div
                style={{
                  padding: "12px",
                  background: "#F8F9F9",
                  borderRadius: "4px",
                }}
              >
                <div style={{ marginBottom: enough_infor_bill ? "" : "12px" }}>
                  {enough_infor_bill
                    ? ""
                    : " Bạn cần bổ sung thông tin hóa đơn trước khi xuất hóa đơn."}
                </div>
                <Button
                  sx={{
                    textTransform: "none",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: enough_infor_bill ? "#009B4B" : "#F58220",
                    border: "1px solid",
                    borderColor: enough_infor_bill ? "#009B4B" : "#F58220",
                    borderRadius: "4px",
                    width: "100%",
                  }}
                  onClick={() => dispatch("openDialogBill")}
                >
                  <img src={enough_infor_bill ? check_ok_icon : info_orange} />
                  <span style={{ marginLeft: "12px" }}>
                    {enough_infor_bill
                      ? "Thông tin hóa đơn"
                      : "Bổ sung thông tin hóa đơn"}
                  </span>
                </Button>
              </div>
            )}
          </div>
        </div>

        <div className={classes.box_feed_3}>
          {((maxSubsidy > 0) && platform === 'app') &&
            <div style={{ marginBottom: "12px" }}>
              <div style={{ fontSize: "14px", marginBottom: "6px" }}>
                Khoản trợ giá
              </div>

              <TextField
                type="tel"
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Nhập số tiền trợ giá"
                error={isInvalid || subsidyValue > maxSubsidy}
                // helperText={isInvalid ? (subsidyValue > maxSubsidy ? `Số tiền vượt quá mức trợ giá tối đa (${formatMoney(maxSubsidy)} VNĐ)` : "Vui lòng nhập số") : ""}
                value={formatMoney(subsidyValue)}
                onChange={(e) => {
                  const raw = e.target.value;
                  const onlyNumber = raw.replace(/\D/g, "");

                  if (raw !== "" && onlyNumber === "") {
                    setIsInvalid(true);
                    return;
                  }
                  setIsInvalid(false);
                  setSubsidyValue(Number(onlyNumber));

                  if (onlyNumber > maxSubsidy) {
                    // setIsInvalid(true);
                    setSubsidyValue(maxSubsidy);
                  }
                }}
                sx={{
                  background: "white",
                  borderRadius: "10px",
                  "& fieldset": {
                    border: "1px solid #C4CFC9 !important",
                    borderRadius: "8px",
                  },
                  "& .MuiInputBase-root": {
                    padding: "8px 15px",
                    background: "white",
                  },
                  "& .MuiInputBase-input": {
                    padding: "0px",
                    height: "28px",
                  },
                  "& .MuiFormHelperText-root": {
                    background: "none",
                    marginLeft: "0px",
                  },

                  "&.MuiFormControl-root": {
                    background: "none",
                  },
                }}

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end"
                      sx={{
                        display: "flex", alignItems: "center",
                        gap: "10px"
                      }}
                    >

                      <span style={{ fontSize: 13, color: "#6C757D" }}>
                        VNĐ
                      </span>
                      {subsidyValue !== "" && <span style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSubsidyValue("")
                          setIsInvalid(false);
                        }}>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.6001 0.600098L0.600098 8.6001M8.6001 8.60009L0.600098 0.600096" stroke="#646D69" stroke-width="1.2" stroke-linecap="round" />
                        </svg></span>}
                      <Button
                        size="small"
                        sx={{
                          color: Number(subsidyValue) === maxSubsidy ? "#8e949a" : "#343A40",
                          fontWeight: 550,
                          minWidth: "unset",
                          padding: "6px 8px",
                          background: "#F0F2F5",
                          border: "0.5px solid #D2D2D2",
                          textTransform: "none",
                          gap: "5px",
                          alignItems: "center",
                          display: "flex",
                          borderRadius: "6px",
                          height: 30
                        }}
                        onClick={() => {
                          setSubsidyValue(maxSubsidy);
                          setIsInvalid(false);
                        }}
                        disabled={Number(subsidyValue) === maxSubsidy}
                      >
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 4.91667L5.125 0.75M5.125 0.75L9.5 4.91667M5.125 0.75L5.125 10.75" stroke="#FB7800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span> Tối đa
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />

              <div
                style={{
                  fontSize: "12px",
                  color: "#F58220",
                  marginTop: "6px",
                  fontStyle: "italic",
                }}
              >
                Khoản trợ giá tối đa: <span style={{ fontWeight: 600 }}>{formatMoney(maxSubsidy)}</span> VNĐ
              </div>
            </div>}

          <div style={{ fontSize: "14px", marginBottom: "6px" }}>Mã ưu đãi</div>
          <div className="row_discoun">
            <TextField
              fullWidth
              sx={{
                background: "white",
                borderRadius: "10px",
                "& fieldset": {
                  border: "1px solid #C4CFC9 !important",
                  borderRadius: "10px",
                },
              }}
              disabled={reward}
              size="small"
              variant="outlined"
              placeholder="Nhập mã ưu đãi"
              value={redeemCode.codeLocal}
              onChange={(e) =>
                dispatch({ type: "onChangeRedeemCode", value: e.target.value })
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={Icon_discountTF} />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              fullWidth
              size="small"
              className="btn_aply"
              sx={{
                background: "#F58220",
                "&.Mui-disabled": { background: "#D2D2D2", color: "white" },
                "&:hover": { background: "#F58220" },
              }}
              onClick={() => dispatch("apllyRedeemConde")}
              disabled={!redeemCode.codeLocal}
            >
              Áp dụng
            </Button>
          </div>
        </div>
        <div className={classes.box_feed_3}>

          <div className="box_fee">
            <div className="rowTotal">
              <div>Tổng phí dịch vụ</div>
              <div>
                {" "}
                {`${fessTotal || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")} vnđ
              </div>
            </div>
            <div className="rowTotal">
              <div>Ưu đãi</div>
              <div>
                {" "}
                {`${redeemCode?.discountAmount || 0}`.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  "."
                )}{" "}
                vnđ
              </div>
            </div>

            {(!!maxSubsidy && (isApp || isZalo_mini)) && (
              <div className="rowTotal">
                <div style={{ fontSize: 14 }}>Trợ giá</div>
                <div style={{ fontSize: 14 }}>{(subsidyValue && !isInvalid) ? formatMoney(subsidyValue) : ''} vnđ</div>
              </div>
            )}

            <div style={{ display: (+reward > 0 && reward ? '' : 'none') }} className="rowTotal">
              <div>Áp dụng tiền thưởng</div>
              <div>
                {" "}
                {`${reward || 0}`.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  "."
                )}{" "}
                vnđ
              </div>
            </div>
            <div className="rowTotal">
              <div className="label-total">Tổng tiền thanh toán</div>
              <div className="green-total">
                {" "}
                {`${(fessTotal || 0) - (redeemCode?.discountAmount || 0) - (reward || 0) - (isInvalid ? 0 : subsidyValue)
                  }`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}{" "}
                vnđ
              </div>
            </div>
          </div>
          {(isApp || isZalo_mini) && (
            <div className="box_discount">
              <div className="rowTotal m-0">
                <div className="label-total">Lương doanh thu</div>
                <div className="origan-total">
                  {" "}
                  {`${(redeemCode?.nonCommission ? 0 : commission?.commission) - (isInvalid ? 0 : subsidyValue) || 0}`.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    "."
                  )}{" "}
                  vnđ
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={classes.box_checkbox_3}>
          <div className="dk">
            <CustomizedCheckbox
              sx={{ padding: "2px", marginRight: "8px" }}
              checked={cam_ket.dung_noi_dung}
              onChange={(e) =>
                dispatch({
                  type: "onCheckCamKet",
                  value: e.target.checked,
                  name: "dung_noi_dung",
                })
              }
            />
            <div>
              <span>
                Tôi xác nhận thông tin kê khai là trung thực, đầy đủ; đã đọc và đồng ý với{" "}
              </span>
              <span
                style={{ color: "#0044CC", cursor: "pointer", textDecoration: "none" }}
                onClick={(ev) => {
                  ev.stopPropagation();
                  OpenLink(
                    "https://zuttoride.vn/quyen-loi-thanh-vien"
                  );
                }}
              >
                Quy tắc & Điều khoản sản phẩm bảo hiểm
              </span>
              <span>; đồng ý để Global Care và các đơn vị liên quan (cổng thanh toán, doanh nghiệp bảo hiểm) chia sẻ, sử dụng thông tin nhằm phát hành, quản lý hợp đồng, tư vấn và hỗ trợ dịch vụ.
              </span>
            </div>
          </div>
          <div className="dk">
            <CustomizedCheckbox
              sx={{ padding: "2px", marginRight: "8px" }}
              checked={cam_ket.tinh_trang_xe}
              onChange={(e) =>
                dispatch({
                  type: "onCheckCamKet",
                  value: e.target.checked,
                  name: "tinh_trang_xe",
                })
              }
            />
            <div>
              <span>Tôi xác nhận tình trạng xe tại thời điểm đăng ký hoạt động tốt và bình thường.</span>
            </div>
          </div>
          <div className="dk">
            <CustomizedCheckbox
              sx={{ padding: "2px", marginRight: "8px" }}
              checked={cam_ket.da_doc}
              onChange={(e) =>
                dispatch({
                  type: "onCheckCamKet",
                  value: e.target.checked,
                  name: "da_doc",
                })
              }
            />
            <div>
              <span>Tôi xác nhận </span>
              <span style={{ fontWeight: 600 }}>là người được bảo hiểm hoặc đã được người được bảo hiểm ủy quyền hợp pháp</span>
              <span> thực hiện giao dịch, và chịu trách nhiệm về tính chính xác của thông tin cũng như mọi khiếu nại liên quan.</span>
            </div>
          </div>
          <div style={{ color: "#BF272D", marginTop: "8px", fontSize: "12px" }}>
            Lưu ý: Khi chọn vào mục này, đồng nghĩa việc kê khai dịch vụ đã
            xong và quý khách không thể cập nhật lại.
          </div>
        </div>
        <SuccessModal {...{ dialogSuccess, dispatch, platform, orders }} />
      </div>
      <BottomButton
        disabled={loadingPrice}
        onBack={() => dispatch("comeBackPage")}
        onClick={() => {
          dispatch("validatePage");
          dispatch("createInsu")
        }}
        title="Tiếp tục"
      />
      <Dialog_Bill {...{ state, dispatch }} />
    </>
  );
}
